import { Component, OnInit } from '@angular/core';
import { ErrorModel } from 'src/app/shared/models/error.model';
import { PlatformEndpointService } from 'src/app/shared/shared.module';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import {
  callbackAdjustCA,
  callbackAdjustSolicitarTC,
} from 'src/app/shared/constants/adjust-callback';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA,
} from 'src/app/shared/constants/dali-fa-ld.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  isLottieImage: boolean;
  isListDescription: boolean;
  errorInfo = new ErrorModel();
  textsClass: {};
  close = false;
  previous = false;
  grayZone: any;
  codBizagi: any;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private endpointService: PlatformEndpointService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private bitacoraService: BitacoraService,
    private adjustEvent: AdjustEvent,
    private parameterService: ParametersService,
    private firmlyApprovedService: FirmlyApprovedService,
    private taggingService: TaggingService,
    private daliService: DaliService,
    public loader: LoaderService,
  ) {
    this.headerService.show(false, false, true);
  }

  /**
   * Summary Get data sent to show the component depending on each case
   */
  ngOnInit() {
    this.errorInfo = this.abreCuentasService.getErrorProperty();
    this.codBizagi = this.abreCuentasService.getSolicitationId();
    console.log('errorcomponent', this.errorInfo);
    this.sendTaggingErrors(this.errorInfo.CODE);
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendErrorPageLoad();
    }

    this.loader.hide('Alta_Productos_zn');
    const productSelected = this.abreCuentasService.getproductSelected();
    if (
      this.errorInfo.title ===
      '¡Tu solicitud fue recibida y la estamos validando!'
    ) {
      if (
        this.abreCuentasService.getPostlogin() !== true &&
        productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS
      ) {
        this.navigationService.pageLoadTag('SolicitudRecibida', [
          '',
          '',
          'pv584',
          '',
        ]);
      } else if (
        this.abreCuentasService.getPostlogin() === true &&
        productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS
      ) {
        this.navigationService.pageLoadTag('SolicitudRecibida', [
          '',
          '',
          'pv94',
          '',
        ]);
      }
      if (
        productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS
      ) {
        const event = {
          eventToken: '9aslpi',
          callbackParams: callbackAdjustCA,
        };
        this.adjustEvent.adjustTrackEvent(event);
      } else if (
        productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC
      ) {
        const event = {
          eventToken: 'iq3a6b',
          callbackParams: callbackAdjustSolicitarTC,
        };
        this.adjustEvent.adjustTrackEvent(event);
      }
      if (
        this.abreCuentasService.getPostlogin() !== true &&
        !this.grayZone === true &&
        productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC
      ) {
        this.navigationService.pageLoadTag('SolicitudEnValidación', [
          'pv420',
          '',
          '',
          '',
        ]);
      } else if (
        this.abreCuentasService.getPostlogin() === true &&
        !this.grayZone === true &&
        productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC
      ) {
        // this.navigationService.pageLoadTag('SolicitudRecibida', ['pv457', '', '', '']);
      }
    }
    if (
      this.errorInfo.title ===
      '¡Tu solicitud fue recibida y la estamos procesando!'
    ) {
      if (
        productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS
      ) {
        const event = {
          eventToken: '7rr5ka',
          callbackParams: callbackAdjustCA,
        };
        this.adjustEvent.adjustTrackEvent(event);
      } else if (
        productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC
      ) {
        this.navigationService.pageLoadTag('SolicitudEnProcesoTimeOut', [
          'pv456',
          '',
          '',
          '',
        ]);
        const event = {
          eventToken: 'l5es1h',
          callbackParams: callbackAdjustSolicitarTC,
        };
        this.adjustEvent.adjustTrackEvent(event);
      }
    }
    if (
      this.errorInfo.type === 'clientless' ||
      this.errorInfo.type === 'loan'
    ) {
      this.headerService.hide();
    }
    if (this.errorInfo.CODE) {
      console.log('this.errorInfo.CODe', this.errorInfo.CODE);

      this.bitacoraService.saveDataInBitacora(
        this.errorInfo.CODE,
      );
    }
    this.isLottieImage = typeof this.errorInfo.image === 'object';
    this.isListDescription = Array.isArray(this.errorInfo.description);

    this.errorInfo.image = this.setimage();

    this.textsClass = this.setTittleClass();
    if (
      this.abreCuentasService.getFlowLoan() &&
      this.errorInfo.buttonAction === '$next'
    ) {
      this.previous = true;
    }
  }

  sendTaggingErrors(code): any {
    if (code === '138' ||
    code === '124' ||
    code === '121' ||
    code === '107' ||
    code === '500') {

      let page;
      let extras: any[];
      extras = [{
        pageValue: 'Error',
      }];
      switch (code) {
        case '138':
          page = '22';
          break;
        case '124':
          page = '23';
          break;
        case '121':
          page = '8';
          break;
        case '500':
          page = '24';
          this.setPageError(extras);
          break;
        case '107':
          page = '24';
          this.setPageError(extras);
          break;
      }
      this.taggingService.sendTaggValues('init', page, '', '', extras);
    }
  }

  setPageError(extras: any[]) {
    const errorText: any = this.errorInfo.description ? this.errorInfo.description : this.errorInfo.title;
    extras.push(...[{
      object: 'transactionTransactionStep',
      value: this.abreCuentasService.getPhase(),
    },
    {
      object: 'errorname',
      value: this.taggingService.applyPascalCaseFormat(errorText),
    }]);
  }

  private setimage() {

    const pathImage = this.parameterService.getSetting(OpEnum.IMAGE_SET)[this.errorInfo.type];
    const img = pathImage ? pathImage : 'AF_farol_roxo.svg';
    return `assets/images/${img}`;

  }

  /**
   * Summary Continues with the next step
   */
  continue() {
    switch (this.errorInfo.buttonAction) {
      case '$exit':
        console.log('Clientless');
        this.navigationService.goToLoginPage();
        break;
      case '$return':
        this.navigationService.returnToCurrentStep();
        break;
      case '$next':
        this.navigationService.nextStep();
        break;
      case '$nextPrincipality':
        this.navigationService.nextStep('203');
        break;
      case '$nextWarningDisplay':
        this.channelCommunicatorService.getChannelId() !== '163' ?
          this.channelCommunicatorService
            .getImpl()
            .openPage(
              this.endpointService.URLS.WARNING_FORM,
              5,
              false,
            ) : window.location.href = this.endpointService.URLS.WARNING_FORM;
        break;
    }
  }
  /**
   * Summary Function to go to offices page
   */
  goToOffices() {
    this.channelCommunicatorService
      .getImpl()
      .openPage(
        this.endpointService.URLS.BRANCH_OFFICE,
        5,
        this.abreCuentasService.getPostlogin(),
      );
  }
  /**
   * Summary Function to go to settings device page
   */
  goToSettingsDevice() {
    this.channelCommunicatorService.getImpl().goToSettingsDevice();
  }

  returnSelectionDate() {
    const has_second_headline = this.abreCuentasService.getSecondHeadline();
    const getOccupation =
      typeof has_second_headline === 'undefined' ||
        !has_second_headline.has_second_headline
        ? this.abreCuentasService.getOccupationSelected()
        : this.abreCuentasService.getOccupationSelectedSecondHeadline();
    const nextStep = getOccupation.id === 1 ? '205' : '206';
    this.navigationService.nextStep(nextStep);
  }

  handleLoadCallToAction(e) {
    if (e.target.className === 'call-to-action-links') {
      this.channelCommunicatorService
        .getImpl()
        .openExternalBrowser(e.target.textContent, 5, true);
    }
  }

  setTittleClass() {
    switch (this.errorInfo.type) {
      case 'errorTecnico':
        return {
          tittle: 'title-tecn',
          paragraph: 'description-tecn',
        };
      case 'success':
        return {
          tittle: 'title-success',
          paragraph: 'description-success',
        };
      case 'bonding-async':
        console.log('caso vinculacion asincrona');
        return {
          tittle: 'title-bonding-async',
          paragraph: 'description-bonding-async',
        };
      case 'zone-grey':
        console.log('caso zona gris');
        return {
          tittle: 'title-zone-grey',
          paragraph: 'description-zone-grey',
        };
      case 'warningDisplay':
        console.log('entro a warningDisplay');
        return {
          tittle: 'title-tecn',
          paragraph: 'description-tecn',
        };
      case 'loan':
        this.close = true;
        return {
          tittle: 'title-loan',
          paragraph: 'description-loan',
          clientless: 'clientless',
        };
      case 'clientless':
        this.close = true;
        return {
          tittle: 'title-clientless',
          paragraph: 'description-clientless',
          clientless: 'clientless',
        };
      case 'info':
        return {
          tittle: 'title-info',
          paragraph: 'description-info',
        };
      default:
        return {
          tittle: 'title',
          paragraph: 'description',
          clientless: 'clientless',
        };
    }
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendErrorPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const errorText: any = this.errorInfo.description ? this.errorInfo.description : this.errorInfo.title;
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv15pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv15pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv15pageFamily.path,
        value: PAGEVIEW_FA.pv15pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv15subFamily.path,
        value: PAGEVIEW_FA.pv15subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv15pageAction.path,
        value: PAGEVIEW_FA.pv15pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv15pageid.path,
        value: ErrorComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv15transactionName.path,
        value: `${PAGEVIEW_FA.pv15transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv15transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv15transactionTransactionStep.value,
      },
      {
        path: PAGEVIEW_FA.pv15errorname.path,
        value: this.taggingService.applyPascalCaseFormat(errorText),
      },
    ];
    this.taggingService.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }
}
